import React from "react";
import IconStart from "@learningblocks/protocol-constants/lib/Icons/start-solid";
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";
import { FullscreenModal } from "@learningblocks/storybook-components";

import "./ProtocolOverviewStyles.scss";
import ProtocolOverviewIcon from "./images/ProtocolOverview-icon.svg";

export interface ProtocolOverviewProps {
  show: boolean;
  close: () => void;
  concentration?: number;
  title: string;
  steps: string[];
  buttonText: string;
  backLabel?: string;
}

export class ProtocolOverview extends React.Component<ProtocolOverviewProps> {
  constructor(props: ProtocolOverviewProps) {
    super(props);
  }

  render() {
    const {
      show,
      close,
      title,
      steps,
      buttonText,
      backLabel = "Lab",
    } = this.props;

    return (
      <FullscreenModal
        className="modalContainer"
        isOpen={show}
        closeButton={true}
        notebookExpanded={false}
        close={close}
        backLabel={backLabel}
      >
        <div className="Question">
          <div className="containerProtocolOverview">
            <div className="modal-section level-choice">
              <img
                src={ProtocolOverviewIcon}
                style={{ height: "130px" }}
                alt="Protocol Overview icon"
              />
              <div className="modal-header">
                <h2>{title}</h2>
              </div>
              <ol style={{ padding: "0 0 0 16px" }}>
                {steps.map((step, index) => (
                  <li key={index} style={{ marginBottom: "16px" }}>
                    {step}
                  </li>
                ))}
              </ol>
              <div className="modal-footer lvl-choice">
                <button
                  aria-label="Start simulation button"
                  className="modal-btn-primary lvl-choice"
                  onClick={close}
                >
                  <IconStart
                    style={{
                      color: colors.charcoal1,
                      height: "16px",
                      top: "2px",
                    }}
                  />
                  {buttonText}
                </button>
              </div>
            </div>
          </div>
        </div>
      </FullscreenModal>
    );
  }
}

export default ProtocolOverview;
